// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"errorPage__2dB3o"};